import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { SsomaService } from 'src/app/services/ssoma/ssoma.service';
import { environment } from 'src/app/environments/environments';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { DynamicFormItem, ExtendedFormControl } from 'src/app/models/interfaces.model';

@Component({
  selector: 'app-investigacion-incidentes',
  templateUrl: './investigacion-incidentes.component.html',
  styleUrls: ['./investigacion-incidentes.component.css']
})
export class InvestigacionIncidentesComponent implements OnInit {

  titulosInforme: { [id: number]: string } = {
    1: 'INFORME TECNICO DE INVESTIGACION DE INCIDENTES',
    2: 'INFORME HVCC',
    // Agregar más títulos según sea necesario
  };
  tituloInforme = '';
  items: any = [];
  isLoading = true;
  myForm!: FormGroup;
  formArrays: any = {};
  public idCounter = 0;
  filesToAdd: { [formArrayName: string]: { file: File; dbColumnName: string }[] } = {};
  accionInseguraCounter = 0;
  IdCompany = '';
  IdModulo = -1; // Nueva propiedad para almacenar el IdModulo
  formArrayNames: string[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private SsomaService: SsomaService,
    private httpClient: HttpClient,
    private route: ActivatedRoute // Inyección del servicio ActivatedRoute
  ) {
    this.myForm = new FormGroup({});
  }

  incrementCounter() {
    this.idCounter++;
  }

  actualizarTituloInforme(): void {
    // Actualiza el título según el valor de IdModulo
    this.tituloInforme = this.titulosInforme[this.IdModulo] || 'Título por defecto';
  }

  async ngOnInit(): Promise<void> {

    // Obtener el parámetro IdModulo de la URL
    this.route.paramMap.subscribe((params) => {
      const idModulo = params.get('idModulo');

      if (idModulo !== null) {
        this.IdModulo = parseInt(idModulo, 10); // Convertir a entero
        this.actualizarTituloInforme(); // Llama a la función para actualizar el título
      } else {
      }

      this.buildFormArrays();
    });
    this.myForm = this.formBuilder.group({});
    await this.getParametersConfig();
    this.buildFormArrays();
  }

  buildFormArrays(): void {
    // Itera sobre las claves (keys) del objeto 'formArrays'
    Object.keys(this.formArrays).forEach((key: string) => {
      // Obtiene el array asociado a la clave actual
      const array = this.formArrays[key];

      // Crea un objeto 'formGroup' para contener los controles del formulario
      const formGroup: any = {};

      // Itera sobre cada elemento del array
      array.forEach((item: any) => {
        // Crea un nuevo control del formulario con el nombre de columna como clave y un FormControl asociado
        formGroup[item.DBNAMECOLUMN] = new FormControl('', item.IS_REQUIRED === item.ID_SUBMODULO ? Validators.required : null);
      });

      // Agrega el FormGroup al formulario principal ('myForm') con el nombre del primer elemento del array
      this.myForm.addControl(array[0].FORMARRAYNAME, this.formBuilder.group(formGroup));

      // Agrega el nombre del FormGroup al array 'formArrayNames'
      this.formArrayNames.push(array[0].FORMARRAYNAME);
    });
  }

  generateFormControlsDynamic(formArray: FormArray, itemsArray: DynamicFormItem[]): void {
    // Itera sobre cada elemento del array 'itemsArray'
    itemsArray.forEach((item) => {
      // Determina si se debe aplicar la validación de requerido y crea un array de validadores
      const validators = item.IS_REQUIRED * 1 === 1 ? [Validators.required] : [];

      // Crea un nuevo control del formulario (FormControl) con los validadores especificados
      const control = this.formBuilder.control('', validators) as ExtendedFormControl;

      // Asigna el nombre de columna a la propiedad 'dbColumnName' del control
      control.dbColumnName = item.DBNAMECOLUMN;

      // Agrega el control al FormArray
      formArray.push(control);
    });
  }

  async getParametersConfig(): Promise<void> {

    // Obtener el contenido de 'Menu' del localStorage
    const menuString = localStorage.getItem('Menu');

    // Verificar si el contenido existe y es válido JSON
    if (menuString) {
      try {
        // convertir la cadena JSON a un objeto JavaScript
        const menuData = JSON.parse(menuString);

        // Extraer las propiedades IdCompany
        this.IdCompany = localStorage.getItem('IdCompany') || '-1'; //menuData.IdCompany;

      } catch (error) {
        // Manejar errores si la cadena no es un JSON válido
        console.error('Error al analizar JSON del menú:', error);
      }
    } else {
      // Manejar el caso en el que no hay datos en 'Menu'
      console.error('No hay datos en el localStorage para la clave "Menu".');
    }

    const Parameters = {
      IdEmpresa: this.IdCompany,
      IdModulo: this.IdModulo,
      /*IdSeccion: 5*/
    };

    try {
      const data = await this.SsomaService.getParametersConfig(Parameters).toPromise();
      data.Items.forEach((itemGroup: any) => {
        const formArrayName = Object.keys(itemGroup)[0];
        const filteredItems = itemGroup[formArrayName] as DynamicFormItem[];
        this.formArrays[formArrayName] = filteredItems;


        const formArray = this.formBuilder.array([], Validators.required);
        this.myForm.addControl(formArrayName, formArray);
        this.generateFormControlsDynamic(formArray, filteredItems);
      });
      this.isLoading = false;
    } catch (error) {
      console.error('Ocurrió un error al obtener los datos:', error);
    }
  }

  sendToLaravel(): void {
    if (this.myForm.valid) {
        const formData = new FormData();
      
        for (const formName in this.myForm.controls) {
            if (this.myForm.controls.hasOwnProperty(formName)) {
                const formArray = this.myForm.get(formName) as FormArray;
                if (formArray) {
                    formArray.controls.forEach((control: any, index: number) => {
                        const value = control.value;
                        let dbColumnName = "";
                        if (control.dbColumnName) {
                            dbColumnName = control.dbColumnName;
                        }
                        formData.append(`${formName}[${index}][value]`, value);
                        formData.append(`${formName}[${index}][dbColumnName]`, dbColumnName);
                    });
                }
            }
        }

        for (const formArrayName in this.filesToAdd) {
            if (this.filesToAdd.hasOwnProperty(formArrayName)) {
                this.filesToAdd[formArrayName].forEach((fileObj, index) => {
                    formData.append(`${formArrayName}[${index}][file]`, fileObj.file, fileObj.file.name);
                    formData.append(`${formArrayName}[${index}][dbColumnName]`, fileObj.dbColumnName);
                });
            }
        }

        const menuString = localStorage.getItem('Menu');
        if (menuString) {
            const menuData = JSON.parse(menuString);
            const IdCompany = menuData.IdCompany;

            formData.append('IdCompany', IdCompany);
        }

        this.httpClient.post<any[]>(environment.apiUrl + '/indama/ssoyma/InsertInventigacionIncidentes', formData).subscribe(
            (response: any) => {
            },
            (error: any) => {
                console.error('Error de solicitud:', error);
            }
        );
    } else {
        console.error('El formulario no es válido. Asegúrate de que se hayan seleccionado todos los valores.');
    }
}

  onFileChange(event: any, index: number): void {
    const file = (event.target as HTMLInputElement).files?.item(0);
    if (file) {
      const formArrayName = Object.keys(this.formArrays)[index];
      const formArray = this.myForm.get(formArrayName) as FormArray;
      if (formArray && formArray.at(0)) {
        const dbColumnName = (formArray.at(0) as ExtendedFormControl).dbColumnName;
        formArray.setValue([{ file, dbColumnName }]);
      }
    }
  }

  onFileAddedR(files: File[], formArrayName: string, index: number, dbColumnName: string): void {
    const formArray = this.myForm.get(formArrayName) as FormArray;
    if (formArray) {
      this.filesToAdd[formArrayName] = [
        ...this.filesToAdd[formArrayName] || [],
        ...files.map(file => ({ file, dbColumnName }))
      ];
      const controls = formArray.controls as FormControl[];
      controls.forEach((control, i) => {
        control.setValue(this.filesToAdd[formArrayName][i]);
      });
    }
  }
  

  onFileAdded(files: File[], formArrayName: string, index: number, dbColumnName: string): void {
    const formArray = this.myForm.get(formArrayName) as FormArray;
    
    if (formArray) {
        this.filesToAdd[formArrayName] = this.filesToAdd[formArrayName] || [];
        
        files.forEach(file => {
            this.filesToAdd[formArrayName].push({ file, dbColumnName });
        });        
        formArray.patchValue(this.filesToAdd[formArrayName]);
    }
}

  onFileRemoved(index: number, formArrayName: string): void {
    const formArray = this.myForm.get(formArrayName) as FormArray;

    if (formArray) {
      // Eliminar el archivo del array filesToAdd
      this.filesToAdd[formArrayName].splice(index, 1);

      // Actualizar los valores de los FormControl en el formArray
      const controls = formArray.controls as FormControl[];

      controls.forEach((control, i) => {
        // Asignar el objeto CustomFile actualizado al FormControl
        control.setValue(this.filesToAdd[formArrayName][i]);
      });
    }

    //VALIDACION DE ELIMINACION
    // Verificar si todos los arreglos están vacíos
    const allEmpty = Object.keys(this.filesToAdd).every(key => this.filesToAdd[key].length === 0);

    // Si todos están vacíos, eliminar la clave
    if (allEmpty) {
      delete this.filesToAdd[formArrayName];
    }

    //Filtrar solo los arreglos con datos
    this.filesToAdd = Object.entries(this.filesToAdd).reduce(
      (obj, [key, value]) => (value.length > 0 ? { ...obj, [key]: value } : obj),
      {} as { [formArrayName: string]: { file: File; dbColumnName: string }[] }
    );
  }



  addDropdownToFormArray(formArrayName: string, index: number): void {
    this.accionInseguraCounter++;
    const formArray = this.myForm.get(formArrayName) as FormArray;
    const newItem = this.formArrays[formArrayName][index];
    const validators = newItem.IS_REQUIRED === newItem.ID_SUBMODULO ? [Validators.required] : [];
    const control = this.formBuilder.control('', validators) as ExtendedFormControl;
    control.dbColumnName = newItem.DBNAMECOLUMN;
    formArray.push(control);
    // Actualiza this.formArrays con el nuevo elemento
    this.formArrays[formArrayName].push({
      FORMARRAYNAME: newItem.FORMARRAYNAME,
      title: newItem.title,
      DBNAMECOLUMN: newItem.DBNAMECOLUMN,
      ID_SUBMODULO: newItem.ID_SUBMODULO,
      COMPONENT_TYPE: newItem.COMPONENT_TYPE,
      IS_REQUIRED: newItem.IS_REQUIRED,
      values: newItem.values
    });
    // Vuelve a construir los FormArrays en el formulario
    this.buildFormArrays();
    // Puedes intentar forzar una actualización del FormArray en la vista utilizando detectChanges
    this.cdr.detectChanges();
  }


  removeItem(formArrayName: string, index: number): void {
    this.accionInseguraCounter--;
    const formArray = this.myForm.get(formArrayName) as FormArray;

    // Verifica si el índice está dentro de los límites del FormArray
    if (formArray && index >= 0 && index < formArray.length) {
      // Elimina el control del FormArray en la posición especificada
      formArray.removeAt(index);

      // Actualiza this.formArrays eliminando el elemento en la misma posición
      this.formArrays[formArrayName].splice(index, 1);

      // Vuelve a construir los FormArrays en el formulario
      this.buildFormArrays();

      // Puedes intentar forzar una actualización del FormArray en la vista utilizando detectChanges
      this.cdr.detectChanges();
    }
  }


  replicarFormulario(): void {
    // Obtener el FormArray 'FORM_I'
    const formularioI = this.myForm.get('FORM_I') as FormArray;

    // Verificar que el FormArray exista
    if (formularioI) {
      // Obtener todos los elementos en el FormArray 'FORM_I'
      const elementosActuales = this.formArrays['FORM_I'];

      // Iterar sobre los elementos y agregar un nuevo FormGroup por cada uno
      elementosActuales.forEach((item: { IS_REQUIRED: any; ID_SUBMODULO: any; DBNAMECOLUMN: string; FORMARRAYNAME: any; title: any; COMPONENT_TYPE: any; values: any; }, index: any) => {
        const validators = item.IS_REQUIRED === item.ID_SUBMODULO ? [Validators.required] : [];
        const control = this.formBuilder.control('', validators) as ExtendedFormControl;
        control.dbColumnName = item.DBNAMECOLUMN;

        formularioI.push(control);

        // Actualizar this.formArrays con el nuevo elemento
        this.formArrays['FORM_I'].push({
          FORMARRAYNAME: item.FORMARRAYNAME,
          title: item.title,
          DBNAMECOLUMN: item.DBNAMECOLUMN,
          ID_SUBMODULO: item.ID_SUBMODULO,
          COMPONENT_TYPE: item.COMPONENT_TYPE,
          IS_REQUIRED: item.IS_REQUIRED,
          values: item.values
        });
      });

      // Volver a construir los FormArrays en el formulario
      this.buildFormArrays();

      // Intentar forzar una actualización del FormArray en la vista utilizando detectChanges
      this.cdr.detectChanges();
    }
  }











}